// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#GeneralInfrastructureRisk .items-indicator{display:flex;flex-direction:column;height:72px;justify-content:space-between}#GeneralInfrastructureRisk .items-indicator span{color:var(--danger);font-size:11px;font-weight:600}#GeneralInfrastructureRisk .items-indicator h3{color:#a3a3a3;font-size:23px;margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
